module.exports = __webpack_public_path__ + "assets/img/feature-img2-79533365.jpg";